import { useParams, useLocation } from "react-router-dom";
import "./../attendance.css";
import RouteModal from "./RouteModal";
import { useEffect, useState } from "react";
import { Spin } from "antd";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import moment from "moment/moment";
import { FaRegCalendarAlt } from "react-icons/fa";
import { MdLogout } from "react-icons/md";
import { LuUsers } from "react-icons/lu";
import { FaLocationDot } from "react-icons/fa6";
import { canView } from "../../../utils/permissions";
import {
  getAttendanceDetailsApi,
  getRouteApi,
  getVisitsApi,
  getSelfiesApi,
} from "./attendanceService";
import SessionTimeline from "./sessionTimeline";
import SelfiesModal from "./SelfiesModal";

const AttendanceDetails = () => {
  const { employeeId } = useParams();
  const location = useLocation();
  const auth = useSelector((state) => state.auth || {});
  const [loading, setLoading] = useState(true);
  const [details, setDetails] = useState(null);
  const [showRoute, setShowRoute] = useState(false);
  const [showSelfies, setShowSelfies] = useState(false);
  const [selectedSession, setSelectedSession] = useState(null);
  const [routeLocations, setRouteLocations] = useState([]);
  const [selfies, setSelfies] = useState([]);
  const [visits, setVisits] = useState([]);

  const selectedDate = location.state?.date;
  const sessions = details?.sessions || [];
  const summary = details?.summary || {};
  const currentStatus = summary.activeSessions > 0 ? "ACTIVE" : "COMPLETED";

  const showVisitButton = canView(auth?.mobile);

  const openRoute = async (session) => {
    await getRoute(session.sessionId);
    await getVisits(session.sessionId);
    // await getSelfiesBySession(session.id);
    setSelectedSession(session);
    setShowRoute(true);
  };
  const openSelfies = async (session) => {
    // await getRoute(session.sessionId);
    // await getVisits(session.sessionId);
    await getSelfiesBySession(session.id);
    setSelectedSession(session);
    setShowSelfies(true);
  };



  const getAttendanceDetails = async () => {
    try {
      setLoading(true);
      const response = await getAttendanceDetailsApi(
        employeeId,
        selectedDate,
        auth.accessToken,
      );
      setDetails(response.data.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const getRoute = async (sessionId) => {
    try {
      const response = await getRouteApi(sessionId, auth.accessToken);

      setRouteLocations(response.data.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  //Visit

  const getVisits = async (sessionId) => {
    try {
      setLoading(true);

      const response = await getVisitsApi(sessionId, auth.accessToken);

      setVisits(response.data.data || []);
    } catch (e) {
      console.log(e);
      setVisits([]);
    } finally {
      setLoading(false);
    }
  };

  const getSelfiesBySession = async (sessionId) => {
    try {
      setLoading(true);
      const response = await getSelfiesApi(sessionId, auth.accessToken);
      setSelfies(response.data.data || []);
    } catch (e) {
      console.log(e);
      setSelfies([]);
    } finally {
      setLoading(false);
    }
  };


  
  useEffect(() => {
    getAttendanceDetails();
  }, [employeeId, selectedDate]);


  if (loading) {
    return (
      <div className="text-center py-5">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <>
      {/* Back Button */}
      <div className="mb-3 text-right">
        <NavLink className="back-nav" to="/attendance">
          Back to Attendance
        </NavLink>
      </div>
      {/* Agent Profile */}

      <div className="card shadow-sm my-4">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div className="d-flex align-items-center">
            <div className="agent-profile-avatar mr-6">
              {employeeId.charAt(0)}
            </div>

            <div className="ms-3">
              <div>
                <h3 className="mb-1 fw-bold">
                  {details?.name}{" "}
                  <span className="font-size-xs text-muted">
                    {moment.utc(selectedDate).local().format("DD-MM-YYYY")}
                  </span>
                </h3>
              </div>

              <div className="text-muted">
                <span>
                  <i className="bi bi-briefcase me-1"></i>
                  {details?.designation}
                </span>
              </div>
            </div>
          </div>

          <div className="text-end">
            <span
              className={`badge ${
                currentStatus === "WORKING"
                  ? "bg-success text-white"
                  : "bg-active-custom text-white"
              } p-3`}
            >
              {currentStatus}
            </span>
          </div>
        </div>
      </div>

      {/* Summary */}

      <div className="row g-3 mb-4">
        <div className="col-lg-3 col-md-6">
          <div className="card summary-card shadow-sm">
            <div className="text-center">
              <div className="summary-icon checkin-card">
                <FaRegCalendarAlt />
              </div>
              <div className="ms-3">
                <small className="text-muted d-block mb-3 font-weight-bolder">
                  First Check In
                </small>
                <h5 className="mb-0">
                  {summary.firstCheckIn
                    ? moment.utc(summary.firstCheckIn).local().format("hh:mm A")
                    : "-"}
                </h5>
               <small className="text-muted d-block mb-3 font-weight-bolder">
                  Battery : {sessions?.[0]?.battery || 0}%
                </small> 
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-3 col-md-6">
          <div className="card summary-card shadow-sm">
            <div className="text-center">
              <div className="summary-icon checkout-card">
                <MdLogout />
              </div>
              <div className="ms-3">
                <small className="text-muted d-block mb-3 font-weight-bolder">
                  Last Check Out
                </small>
                <h5 className="mb-0">
                  {summary.lastCheckOut
                    ? moment.utc(summary.lastCheckOut).local().format("hh:mm A")
                    : "-"}
                </h5>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-3 col-md-6">
          <div className="card summary-card shadow-sm">
            <div className="text-center">
              <div className="summary-icon visit-card">
                <LuUsers />
              </div>
              <div className="ms-3">
                <small className="text-muted d-block mb-3 font-weight-bolder">
                  Total Visits
                </small>
                <h5 className="mb-0">{summary.totalVisits ?? 0}</h5>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-3 col-md-6">
          <div className="card summary-card shadow-sm">
            <div className="text-center">
              <div className="summary-icon distance-card">
                <FaLocationDot />
              </div>
              <div className="ms-3">
                <small className="text-muted d-block mb-3 font-weight-bolder">
                  Distance
                </small>

                <h5 className="mb-0 fw-bold">
                  {summary.totalDistanceKm
                    ? summary.totalDistanceKm.toFixed(2)
                    : "0.00"}{" "}
                  km
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card shadow-sm p-0">
        <SessionTimeline
          details={details}
          sessions={sessions}
          openRoute={openRoute}
          showVisitButton={showVisitButton}
          selfies={selfies}
          openSelfies={openSelfies}
        />
      </div>

      <RouteModal
        show={showRoute}
        onClose={() => {
          setShowRoute(false);
          setRouteLocations([]);
          setSelfies([]);
        }}
        session={selectedSession}
        visits={visits}
        locations={routeLocations}
      />

      <SelfiesModal
        show={showSelfies}
        onClose={() => {
          setShowSelfies(false);
          // setRouteLocations([]);
          setSelfies([]);
        }}
        session={selectedSession}
        // visits={visits}
        selfies={selfies}
        // locations={routeLocations}
      />

    </>
  );
};

export default AttendanceDetails;
